const $win = $(window);

$('.js-nav-accordion > ul > li > a').on('click', function(e) {
  if ($win.width() < 768) {
    e.preventDefault();

    $(this)
      .siblings()
      .slideToggle()
      .closest('li')
      .toggleClass('expanded');
  };
});



// WEBPACK FOOTER //
// ../assets/js/footer-accordion.js